import axios from "axios";
import {getServerURL} from "../Common/Appcommon";
const BASE_URL = getServerURL();
export default axios.create({
    baseURL: BASE_URL,
});
